module.exports = __webpack_public_path__ + "img/section5-item3.ce02c380.svg";